/*获取token*/
export function getToken() {
    const token = localStorage.getItem('emailToken')
    return token ? token : null
}

/*存储用户token*/
export function setToken(token) {
    return localStorage.setItem('emailToken', token)
}